import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import { ScreeningStatus } from 'src/models/virtualCard.models'
import {
  ScreenVirtualCardMatchParams,
  screenVirtualCardRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectVirtualCardIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<ScreenVirtualCardMatchParams>(
      location.pathname,
      screenVirtualCardRouteProps,
    ) as match<ScreenVirtualCardMatchParams>
    return mtch.params.id
  },
)
export const selectPostingUserScreenFromState = (state: RootState): boolean =>
  state.app.screenVirtualCard.postingUserScreen
export const selectPostingUserScreenTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.screenVirtualCard.postingUserScreenTopLevelError
export const selectPostingUserScreenErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.screenVirtualCard.postingUserScreenErrorDetailMap
export const selectScreeningStatusFromState = (
  state: RootState,
): ScreeningStatus | undefined => state.app.screenVirtualCard.screeningStatus
